<template>
  <section v-if="messages.length > 0">
    <section class="post-it" v-for="(message, index) in messages" :key="index">
      <div class="tape"></div>
      <div
        class="paper"
        :style="{ 'background-color': message.backgroundColor }"
      >
        <close-button
          @click="removeMsg(message.id)"
          class="close-button"
          color="#4f4f4f"
          v-if="showClose"
        ></close-button>

        <div class="content" v-html="message.content"></div>

        <div class="post-it-btn-holder myclearfix">
          <button
            v-for="(btn, index) in message.buttons"
            :key="index"
            class="post-it-btn"
            v-show="btn.label"
            :style="{
              color: btn.textColor,
              'border-color': btn.borderColor,
              'background-color': btn.backgroundColor
            }"
            @click="messageAction(btn.type, btn.value, btn.label, message.id)"
          >
            {{ btn.label }}
          </button>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import { hideMessage } from '@/api/messagesApi'
import InteractionMixin from '@/mixins/InteractionMixin'

export default {
  data() {
    return {
      // messages: []
    }
  },
  mixins: [InteractionMixin],
  computed: {
    messages() {
      return this.rootStore.messages || []
    }
  },
  methods: {
    messageAction(type, value, label, id) {
      id = parseInt(id)
      switch (type) {
        case 'url':
          this.removeMsg(id)
          window.open(value)
          return
        case 'close':
          this.removeMsg(id)
          return
      }
    },
    removeMsg(id) {
      id = parseInt(id)

      hideMessage(id).then((resp) => {
        if (resp) {
          //store.commit('hideMessage', id)
          let newMessages = []
          this.messages.forEach((message, index) => {
            if (message.id != id) {
              newMessages.push(message)
            }
          })
          this.rootStore.hydrateMessages(newMessages)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.post-it {
  position: absolute;

  &:nth-child(5n + 1) {
    transform: rotate(-2deg);
  }

  &:nth-child(5n + 2) {
    transform: rotate(1.6deg);
  }

  &:nth-child(5n + 3) {
    transform: rotate(-6.5deg);
  }

  &:nth-child(5n + 4) {
    transform: rotate(0deg);
  }

  &:nth-child(5n + 5) {
    transform: rotate(4deg);
  }
}

.close-button {
  position: absolute;
  right: 15px;
  top: 15px;
}

.tape {
  transform: rotate(-1deg);
  background-color: rgba(255, 255, 255, 0.5);
  margin-left: 85px;
  height: 37px;
  position: relative;
  width: 122px;
  z-index: 1;
}

.paper {
  box-shadow: rgba(0, 0, 0, 0.4) 0px 4px 20px;
  background-color: #f5ef94;
  color: #4a4a4a;
  font-size: 14px;
  min-height: 220px;
  margin-top: -17px;
  padding: 25px 15px 15px;
  position: relative;
  width: 301px;
}
.content {
  min-height: 175px;
  font-size: 14px;
  line-height: normal;

  p {
    font-size: 12px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 600;
  }

  h1 {
    font-size: 32px;
  }

  h2 {
    font-size: 28px;
  }

  h3 {
    font-size: 24px;
  }

  h4 {
    font-size: 20px;
  }

  h5 {
    font-size: 18px;
  }

  h6 {
    font-size: 16px;
  }
}

button.post-it-btn {
  border-radius: 24px;
  background-color: transparent;
  border: 1px solid rgba(0, 0, 0, 0.35);
  color: rgba(0, 0, 0, 0.5);
  float: right;
  padding: 0 10px;
  height: 25px;
  line-height: 25px;
  margin: 2px;
  white-space: nowrap;
}
</style>
